"use client";

import { ShieldCheck, Percent, Image as ImageIcon } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Totholzentfernung",
  description: "Sicherheit an erster Stelle. Wir entfernen abgestorbene Äste fachgerecht, um Personen- und Sachschäden durch Windbruch oder Sturm zuverlässig zu verhindern.",
  icon: ShieldCheck
}, {
  title: "Gebäudefreischnitt",
  description: "Schutz für Ihre Immobilie. Wir schneiden Äste von Fassaden und Dächern frei, um Feuchtigkeitsschäden zu stoppen und den Wert Ihres Hauses zu erhalten.",
  icon: Percent
}, {
  title: "Baumpflege & Vitalität",
  description: "Nachhaltige Baumgesundheit. Durch präzise Schnitte fördern wir die Vitalität Ihrer Bäume und sorgen für ein ästhetisches sowie gesundes Wachstum.",
  icon: ImageIcon
}];
export default function BundleBenefits() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}